import React from 'react';

const CompanyDetailsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/multipleCompanies/details',
            exact: true,
			component: React.lazy(() => import('./CompanyDetails'))
		}
	]
};

export default CompanyDetailsConfig;
